import { updateItems } from '@/mocks/home';

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              更新快讯
            </h2>
          </div>

          <div className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden">
            <div className="divide-y divide-background-200/50">
              {updateItems.map((item, idx) => (
                <a
                  key={idx}
                  href="#updates"
                  className="flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 hover:bg-background-50 transition-colors cursor-pointer group"
                >
                  <span className="text-xs font-mono text-foreground-400 whitespace-nowrap min-w-[44px]">
                    {item.date}
                  </span>
                  <span
                    className={`shrink-0 px-2 py-0.5 text-[10px] font-medium rounded whitespace-nowrap ${
                      item.tagColor === 'primary'
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-accent-100 text-accent-700'
                    }`}
                  >
                    {item.tag}
                  </span>
                  <span className="text-sm text-foreground-700 group-hover:text-primary-600 transition-colors line-clamp-1 flex-1">
                    {item.title}
                  </span>
                  <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-400 transition-colors text-lg shrink-0 hidden sm:block"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}